import { parseNormalizationResponse } from '@updater/ui-widgets';
import { format } from 'date-fns';
import { FormData, Address } from './types';
import { SignupMoverVariables } from 'types/generated/SignupMover';

export const routeMaybeWithQuery = (base: string, query?: string) =>
  query === undefined ? base : `${base}?${query}`;

export const addressForQuery = ({
  normalizationResponse,
  ...address
}: Address) => {
  return {
    ...address,
    ...(normalizationResponse &&
      parseNormalizationResponse(normalizationResponse)),
  };
};

export const formatValues = ({
  movingFromOutsideCountry,
  fromAddress,
  fromOutsideCountryAddress,
  homeSize,
  toAddress,
  ownership,
  moveDate,
  optIn, // prop to seperate from otherValues - not being used currently
  ...otherValues
}: FormData): SignupMoverVariables['input'] => {
  return {
    move: {
      fromAddress:
        movingFromOutsideCountry === 'No'
          ? {
              ...addressForQuery(fromAddress as Address),
              homeSize,
            }
          : {
              city: fromOutsideCountryAddress?.city,
              postalCode: '00000',
              state: '000',
              street: fromOutsideCountryAddress?.street,
              country: fromOutsideCountryAddress?.country,
              unit: fromOutsideCountryAddress?.unit,
            },
      toAddress: {
        ...addressForQuery(toAddress),
        ownership,
      },
      moveDate: format(new Date(moveDate), `yyyy-MM-dd'T'HH':'mm':'ss`),
    },
    mover: {
      metadata: {},
      ...otherValues,
    },
    promotions: [],
  };
};
